module.exports = __webpack_public_path__ + "static/tat-23-53779ef95aab8ebc2f2cad6adc5b5294.jpg";